/**
 * Created by piotr.pozniak@thebeaverhead.com on 11/04/2023
 */

import React, { useEffect } from "react";

/**
 *
 * @param props
 * @param {function} props.onClose
 * @returns {React.JSX.Element}
 * @constructor
 */
const Dropdown = (props) => {
  useEffect(() => {
    // if user clicks outside of dropdown, call props.onClose callback
    const handleClickOutside = (e) => {
      if (props.onClose && !e.target.closest(".filters")) {
        props.onClose();
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return <div className={"filters__dropdown"}>{props.children}</div>;
};

export default Dropdown;
